import { ExpandLess, ExpandMore } from "@mui/icons-material";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import { useEffect, useState } from "react";
import { useTheme as useMuiTheme } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { localStorageItemNames } from "../../common/constants";
import { navDealerItems, navItems } from "../../common/constants/navItems";
import { useAuth, useMovableColumn, useUser, useSidebar, useColor } from "../../common/hooks";
import { layoutStyle } from "./style";
import { PageNameConstant } from "../../common/constants/PageNameConstant";

const drawerWidth = 200;

export const Sidebar = () => {
  const classes = layoutStyle();
  const navigate = useNavigate();
  const { isSidebarOpen } = useSidebar();
  const { colorSidebar } = useColor();
  const currentWidth = isSidebarOpen ? drawerWidth : 70;
  const { userLoggin } = useAuth();
  const muiTheme = useMuiTheme();
  const {
    userData,
    getUserById,
    selectedNav,
    setSelectedNav,
    columnChange,
    setColumnChange,
    setPopupBlock,
    sidebarColumnPopup,
    setSidebarColumnPopup,
    setSelectedSaveNav,
    selectedItemIndex,
    setSelectedItemIndex,
  } = useUser();
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const [openChildMenu, setOpenChildMenu] = useState(null);
  const [selectedSubItemIndex, setSelectedSubItemIndex] = useState(null);
  const [userType, setUserType] = useState();
  const location = useLocation();
  const [activeMenuItem, setActiveMenuItem] = useState("");
  const { setMovableColumn } = useMovableColumn();
  useEffect(() => {
    const typeValue = localStorage.getItem("type");
    if (typeValue) {
      setUserType(typeValue);
    }
    const localUserId = localStorage.getItem(localStorageItemNames.userID) || userLoggin?.userId;
    if (localUserId) {
      getUserById(localUserId);
    }
  }, [userLoggin, getUserById]);

  useEffect(() => {
    const { pathname } = location;
    const activeItem = findActiveItem(navItems, pathname);
    setActiveMenuItem(activeItem?.name || "");
  }, [location]);

  const findActiveItem = (items, pathname) => {
    for (let item of items) {
      if ("/"+item.path === pathname) {
        return item;
      }
      if (item.subMenu) {
        const activeSubItem = findActiveItem(item.subMenu, pathname);
        if (activeSubItem) {
          return activeSubItem;
        }
      }
    }
    return null;
  };
  const handleSubMenuClick = (index) => {
    setOpenSubMenu(openSubMenu === index ? null : index);
  };

  const onMenuItemClick = (nav, index) => {
    setOpenChildMenu(openChildMenu === index ? null : index);
    const slectItem = navItems?.filter((item) => item?.name === nav?.name);
    setSelectedSubItemIndex(null);
    setSelectedItemIndex(index);
    if (slectItem?.length > 0) {
      setSelectedNav(slectItem[0]?.name);
    }

    if (columnChange) {
      setPopupBlock(true);
      setColumnChange(false);
      setSidebarColumnPopup(nav?.path);
    } else {
      setSidebarColumnPopup(nav?.path);
      setColumnChange(false);
      setMovableColumn([]);
      setPopupBlock(false);
      navigate(nav?.path);
    }
  };

  const onSubItemClick = (nav, index, array) => {
    setSelectedItemIndex(null);
    setSelectedSubItemIndex(index);
    const slectItem = array?.filter((item) => item?.name === nav?.name);
    if (slectItem?.length > 0) {
      setSelectedNav(slectItem[0]?.name);
    }
    if (columnChange) {
      setPopupBlock(true);
      if (slectItem?.length > 0) {
        setSelectedSaveNav(slectItem[0]?.name);
      }
      setColumnChange(false);
      setSidebarColumnPopup(nav?.path);
    } else {
      if (slectItem?.length > 0) {
        setSelectedSaveNav(slectItem[0]?.name);
      }
      setSidebarColumnPopup(nav?.path);
      setColumnChange(false);
      setMovableColumn([]);
      setPopupBlock(false);
      navigate(nav?.path);
    }
  };

  return (
    <>
      <Drawer
        variant="permanent"
        sx={{
          width: currentWidth,
          flexShrink: 0,
          transition: "width 0.3s ease",
          [`& .MuiDrawer-paper`]: {
            width: currentWidth,
            transition: "width 0.3s ease",
            overflowX: "hidden",
            boxSizing: "border-box",
            background: colorSidebar || muiTheme.palette.background.paper,
            borderRight: `1px solid var(--divider)`,
            boxShadow: "none",
          },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: "auto", height: "100%" }}>
          <List style={{ paddingTop: 1 }}>
            {(userType === "admin" || userData?.type?.toLowerCase() === "admin"
              ? navItems
              : navDealerItems
            )?.map((nav, index) => (
              <React.Fragment key={nav?.name}>
                {nav?.subMenu ? (
                  <>
                    <ListItemButton
                      onClick={() => handleSubMenuClick(index)}
                      sx={{
                        margin: "4px 8px",
                        borderRadius: "8px",
                        fontWeight: "bold",
                        justifyContent: isSidebarOpen ? "initial" : "center",
                        px: 2.5,
                        "&:hover": {
                          bgcolor: muiTheme.palette.mode === "dark" ? "rgba(255,255,255,0.05)" : "rgba(8,96,211,0.04)",
                          color: `${muiTheme.palette.primary.main} !important`,
                        },
                        "&:hover .MuiListItemIcon-root": {
                          color: `${muiTheme.palette.primary.main} !important`,
                        },
                        "&:hover .MuiSvgIcon-root": {
                          color: `${muiTheme.palette.primary.main} !important`,
                        },
                      }}
                      style={{
                        backgroundColor: openSubMenu === index ? (muiTheme.palette.mode === "dark" ? "rgba(255,255,255,0.02)" : "rgba(0,0,0,0.02)") : "transparent",
                        color: openSubMenu === index ? muiTheme.palette.primary.main : muiTheme.palette.text.primary,
                      }}
                    >
                      <ListItemIcon
                        style={{
                          padding: "5px",
                          minWidth: 0,
                          mr: isSidebarOpen ? 3 : "auto",
                          justifyContent: "center",
                          color: openSubMenu === index ? muiTheme.palette.primary.main : muiTheme.palette.text.secondary,
                        }}
                      >
                        {nav?.icon}
                      </ListItemIcon>
                      {isSidebarOpen && (
                        <>
                          <span
                            className={classes.subMenuHover}
                            style={{
                              fontWeight: 500,
                              marginLeft: 16,
                              flex: 1,
                              color: muiTheme.palette.text.primary,
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                            }}
                          >
                            {nav?.name}
                          </span>
                          {openSubMenu === index ? (
                            <ExpandLess sx={{ color: muiTheme.palette.primary.main }} />
                          ) : (
                            <ExpandMore sx={{ color: muiTheme.palette.text.secondary }} />
                          )}
                        </>
                      )}
                    </ListItemButton>
                    <Collapse
                      in={openSubMenu === index && isSidebarOpen}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List component="div" disablePadding>
                        {nav?.subMenu?.map((subNavItem, subIndex) => (
                          <ListItem
                            key={subNavItem.name}
                            disablePadding
                            onClick={() =>
                              onSubItemClick(subNavItem, subIndex, nav?.subMenu)
                            }
                            sx={{
                              margin: "2px 8px",
                              borderRadius: "8px",
                              "&:hover": {
                                bgcolor: muiTheme.palette.mode === "dark" ? "rgba(255,255,255,0.05)" : "rgba(8,96,211,0.04)",
                                color: `${muiTheme.palette.primary.main} !important`,
                              },
                              "&:hover .MuiListItemIcon-root": {
                                color: `${muiTheme.palette.primary.main} !important`,
                              },
                              ".MuiListItemIcon-root": {
                                color:
                                  selectedNav === subNavItem.name
                                    ? muiTheme.palette.primary.main
                                    : muiTheme.palette.text.secondary,
                              },
                            }}
                            style={{
                              backgroundColor:
                                selectedNav === subNavItem.name
                                  ? muiTheme.palette.mode === "dark" ? "rgba(56,189,248,0.1)" : "rgba(8,96,211,0.08)"
                                  : "transparent",
                              color:
                                selectedNav === subNavItem.name
                                  ? muiTheme.palette.primary.main
                                  : muiTheme.palette.text.primary,
                            }}
                          >
                            <ListItemButton
                              sx={{
                                pl: 4,
                                fontWeight: "bold",
                                justifyContent:
                                  isSidebarOpen ? "initial" : "center",
                                px: 2.5,
                              }}
                            >
                              <ListItemIcon
                                style={{
                                  padding: "5px",
                                  minWidth: 0,
                                  mr: isSidebarOpen ? 3 : "auto",
                                  justifyContent: "center",
                                  color: muiTheme.palette.text.secondary,
                                }}
                              >
                                {subNavItem?.icon}
                              </ListItemIcon>
                              {isSidebarOpen && (
                                <span style={{
                                  fontWeight: 500,
                                  marginLeft: 16,
                                  flex: 1,
                                  color: muiTheme.palette.text.primary,
                                  wordBreak: "break-word",
                                  whiteSpace: "normal",
                                }}>
                                  {subNavItem?.name}
                                </span>
                              )}
                            </ListItemButton>
                          </ListItem>
                        ))}
                      </List>
                    </Collapse>
                  </>
                ) : (
                  <ListItem
                    key={nav?.name}
                    disablePadding
                    onClick={() => onMenuItemClick(nav, index)}
                    sx={{
                      margin: "4px 8px",
                      borderRadius: "8px",
                      "&:hover": {
                        bgcolor: muiTheme.palette.mode === "dark" ? "rgba(255,255,255,0.05)" : "rgba(8,96,211,0.04)",
                        color: `${muiTheme.palette.primary.main} !important`,
                      },
                      "&:hover .MuiListItemIcon-root": {
                        color: `${muiTheme.palette.primary.main} !important`,
                      },
                      ".MuiListItemIcon-root": {
                        color:
                          selectedNav === nav?.name
                            ? muiTheme.palette.primary.main
                            : muiTheme.palette.text.secondary,
                      },
                    }}
                    style={{
                      backgroundColor:
                        selectedNav === nav?.name
                          ? muiTheme.palette.mode === "dark" ? "rgba(56,189,248,0.1)" : "rgba(8,96,211,0.08)"
                          : "transparent",
                      color:
                        selectedNav === nav?.name
                          ? muiTheme.palette.primary.main
                          : muiTheme.palette.text.primary,
                    }}
                  >
                    <ListItemButton
                      sx={{
                        fontWeight: "bold",
                        justifyContent: isSidebarOpen ? "initial" : "center",
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        style={{
                          padding: "5px",
                          minWidth: 0,
                          mr: isSidebarOpen ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        {nav?.icon}
                      </ListItemIcon>
                      {isSidebarOpen && (
                        <span style={{
                          fontWeight: 500,
                          marginLeft: 16,
                          flex: 1,
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}>
                          {nav?.name}
                        </span>
                      )}
                    </ListItemButton>
                  </ListItem>
                )}
              </React.Fragment>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
};
